/*
  calculateur.js
  ----------------
  Récupère les données du formulaire, POST /calculate, affiche les résultats.
  - Désactive le bouton pendant la requête
  - Gère erreurs serveur / validation simple
  - Envoie header 'x-site-index' si le container a data-site-index
  - Compatible avec le endpoint /calculate fourni dans server.js
*/

// calculateur.js
// chargé via {{ 'calculateur.js' | asset_url | script_tag }}
document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('imc-macro-calculator-form');
  const resultsWrap = document.getElementById('imc-macro-calculator-results');
  const summaryWrap = document.getElementById('imc-summary');
  const macrosWrap = document.getElementById('imc-macros');
  const totalsWrap = document.getElementById('imc-totals');
  const container = document.getElementById('imc-macro-calculator');

  if (!form) return;

  // utilitaires
  function formatNumber(n, decimals = 0) {
    if (typeof n !== 'number' || !Number.isFinite(n)) return '-';
    return n.toLocaleString('fr-FR', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
  }

  function escapeHtml(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#039;');
  }

  function showError(message) {
    // affichage simple : injecte dans summary area en rouge
    summaryWrap.innerHTML = `<div class="col-span-1 sm:col-span-2 p-3 bg-red-50 border border-red-100 rounded-md text-red-700">${escapeHtml(message)}</div>`;
    macrosWrap.innerHTML = '';
    totalsWrap.textContent = '';
    resultsWrap.classList.remove('hidden');
  }

  // validate numeric fields client-side with clarity
  function parsePositiveNumber(value) {
    const n = Number(value);
    return (Number.isFinite(n) && n >= 0) ? n : NaN;
  }

  // build small progress bar (DOM)
  function buildBar(percentage) {
    const outer = document.createElement('div');
    outer.className = 'w-full bg-gray-200 rounded-full h-2 overflow-hidden';
    const inner = document.createElement('div');
    inner.style.width = Math.min(100, Math.max(0, percentage)) + '%';
    inner.className = 'h-2 bg-black';
    outer.appendChild(inner);
    return outer;
  }

  // show results (new attractive layout)
  function showResults(data) {
    // compat layer (server may send old keys)
    const proteins_g = Number.isFinite(data.proteins_g) ? data.proteins_g : (Number.isFinite(data.protein) ? data.protein : 0);
    const proteins_kcal = Number.isFinite(data.proteins_kcal) ? data.proteins_kcal : Math.round(proteins_g * 4);

    const fats_g = Number.isFinite(data.fats_g) ? data.fats_g : (Number.isFinite(data.fat) ? data.fat : 0);
    const fats_kcal = Number.isFinite(data.fats_kcal) ? data.fats_kcal : Math.round(fats_g * 9);

    const carbs_g = Number.isFinite(data.carbs_g) ? data.carbs_g : (Number.isFinite(data.carbs) ? data.carbs : 0);
    const carbs_kcal = Number.isFinite(data.carbs_kcal) ? data.carbs_kcal : Math.round(carbs_g * 4);

    const caloric = (Number.isFinite(data.caloric_needs) ? data.caloric_needs : (Number.isFinite(data.calories_goal) ? data.calories_goal : null));
    const bmr = Number.isFinite(data.bmr) ? data.bmr : '-';
    const tdee = Number.isFinite(data.tdee) ? data.tdee : '-';
    const bmi = Number.isFinite(data.bmi) ? data.bmi : '-';

    // Summary card (IMC + calories big)
    summaryWrap.innerHTML = `
      <div class="p-4 bg-gray-50 rounded-lg border border-gray-100 flex items-center gap-4">
        <div class="flex-1">
          <div class="text-xs text-gray-500">IMC</div>
          <div class="text-2xl font-semibold">${formatNumber(bmi,1)}</div>
        </div>
        <div class="flex-1">
          <div class="text-xs text-gray-500">Besoins caloriques</div>
          <div class="text-2xl font-semibold">${caloric !== null ? formatNumber(caloric,0) + ' kcal' : '-'}</div>
        </div>
      </div>
    `;

    // Macros: cards (g + kcal + % of calories + bar)
    macrosWrap.innerHTML = ''; // clear
    const macros = [
      { id: 'proteins', label: 'Protéines', g: proteins_g, kcal: proteins_kcal, kcalPerGram: 4 },
      { id: 'fats', label: 'Graisses', g: fats_g, kcal: fats_kcal, kcalPerGram: 9 },
      { id: 'carbs', label: 'Glucides', g: carbs_g, kcal: carbs_kcal, kcalPerGram: 4 }
    ];

    macros.forEach(m => {
      const card = document.createElement('div');
      card.className = 'p-3 bg-white rounded-lg border border-gray-100 shadow-sm flex flex-col gap-2';

      const heading = document.createElement('div');
      heading.className = 'flex items-baseline justify-between';
      heading.innerHTML = `<div class="text-sm text-gray-600">${escapeHtml(m.label)}</div>
                           <div class="text-lg font-semibold">${formatNumber(m.g,0)} g</div>`;
      card.appendChild(heading);

      const sub = document.createElement('div');
      sub.className = 'text-xs text-gray-500 flex items-center justify-between';
      const pct = (caloric && caloric > 0) ? Math.round((m.kcal / caloric) * 1000) / 10 : 0;
      sub.innerHTML = `<div>${formatNumber(m.kcal,0)} kcal</div><div>${formatNumber(pct,1)} %</div>`;
      card.appendChild(sub);

      card.appendChild(buildBar(pct));

      macrosWrap.appendChild(card);
    });

    // totals / details
    totalsWrap.innerHTML = `BMR: ${formatNumber(bmr,0)} kcal · TDEE: ${formatNumber(tdee,0)} kcal · Multiplicateur: ${typeof data.goal_multiplier !== 'undefined' ? data.goal_multiplier : '-'}`;

    resultsWrap.classList.remove('hidden');
    // scroll into view (accessible)
    resultsWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // simple JSON-safe parse helper for fetch responses
  async function parseJsonSafe(resp) {
    const text = await resp.text();
    try {
      return JSON.parse(text);
    } catch (err) {
      throw new Error('Réponse serveur illisible (JSON attendu).');
    }
  }

  // FORM submit handler
  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    resultsWrap.classList.add('hidden');
    summaryWrap.innerHTML = '';
    macrosWrap.innerHTML = '';
    totalsWrap.textContent = '';

    const fd = new FormData(form);
    const gender = fd.get('gender');
    const ageRaw = fd.get('age');
    const weightRaw = fd.get('weight');
    const heightRaw = fd.get('height');
    const activity_level = fd.get('activity_level');
    const goal = fd.get('goal');

    // Parse numbers and validate
    const age = Number(ageRaw);
    const weight = Number(weightRaw);
    const height = Number(heightRaw);

    if (!gender || !activity_level || !goal) {
      showError('Veuillez sélectionner le sexe, le niveau d\'activité et l\'objectif.');
      return;
    }
    if (!Number.isFinite(age) || age <= 0) {
      showError('L\'âge doit être un nombre entier supérieur à 0.');
      return;
    }
    if (!Number.isFinite(weight) || weight <= 0) {
      showError('Le poids doit être un nombre supérieur à 0 (kg).');
      return;
    }
    if (!Number.isFinite(height) || height <= 0) {
      showError('La taille doit être un nombre supérieur à 0 (cm).');
      return;
    }

    // Prepare payload
    const payload = { gender, age, weight, height, activity_level, goal };
    const headers = { 'Content-Type': 'application/json' };
    const siteIndexAttr = container && container.dataset && container.dataset.siteIndex;
    if (typeof siteIndexAttr !== 'undefined') headers['x-site-index'] = String(siteIndexAttr);

    // button state
    const submitBtn = document.getElementById('calculateBtn') || form.querySelector('button[type="submit"]');
    let origHtml = null;
    try {
      if (submitBtn) {
        submitBtn.setAttribute('disabled', 'disabled');
        origHtml = submitBtn.innerHTML;
        submitBtn.innerHTML = `<span class="inline-block animate-spin mr-2 align-middle" style="border:2px solid transparent;border-top-color:currentColor;border-right-color:currentColor;width:1em;height:1em;border-radius:50%"></span><span>Calcul en cours…</span>`;
      }

      const resp = await fetch('https://jayfit.onrender.com/calculate', {
        method: 'POST',
        headers,
        body: JSON.stringify(payload),
        credentials: 'same-origin'
      });

      const json = await parseJsonSafe(resp);

      if (!resp.ok || !json || json.ok === false) {
        const errMsg = (json && (json.error || json.message)) ? (json.error || json.message) : `Erreur serveur (${resp.status})`;
        showError(errMsg);
        return;
      }

      if (json && json.data) {
        showResults(json.data);
      } else {
        showError('Réponse inattendue du serveur.');
      }
    } catch (err) {
      console.error('calculateur.js error', err);
      showError(err && err.message ? err.message : 'Erreur lors de la requête.');
    } finally {
      if (submitBtn) {
        submitBtn.removeAttribute('disabled');
        if (origHtml !== null) submitBtn.innerHTML = origHtml;
      }
    }
  });

  // Optional: prevent non-numeric characters in numeric inputs on mobile/desktop
  ['age','weight','height'].forEach(id => {
    const el = document.getElementById(id);
    if (!el) return;
    el.addEventListener('input', (ev) => {
      // remove accidental spaces
      el.value = String(el.value).trim();
    });
  });

  // Log script loaded for debug (remove in prod if desired)
  console.debug('calculateur.js loaded');
});
